import { c as _c } from "react/compiler-runtime";
import { graphql } from "@opensea/graphql";
import { useSubscription } from "@/hooks/use-subscription";
import { NotificationsTableRowFragment } from "./NotificationsTableRow.fragment";
const subscription = graphql(`
    subscription useNotificationSubscription($address: Address!) {
      notifications(address: $address) {
        __typename
        ... on ItemBoughtNotification {
          occurredAt
          isRead
        }
        ... on ItemSoldNotification {
          occurredAt
          isRead
        }
        ... on BulkPurchaseNotification {
          occurredAt
          isRead
        }
        ... on BulkSaleNotification {
          occurredAt
          isRead
        }
        ... on RewardReadyToClaimNotification {
          occurredAt
          isRead
        }
        ... on MintNotification {
          occurredAt
          isRead
        }
        ... on DropStageReminderNotification {
          occurredAt
          isRead
        }
        ... on ShipmentReceivedNotification {
          occurredAt
          isRead
        }
        ...NotificationsTableRow
      }
    }
  `, [NotificationsTableRowFragment]);
export function useNotificationSubscription(t0) {
  const $ = _c(8);
  const {
    address,
    setItems,
    incrementCount
  } = t0;
  const t1 = address ?? "";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      address: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = !address;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = {
      query: subscription,
      variables: t2,
      pause: t3
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== incrementCount || $[6] !== setItems) {
    t5 = data => {
      const notification = data.notifications;
      const unreadCount = notification.isRead ? 0 : 1;
      setItems(prev => [notification, ...prev]);
      incrementCount?.(unreadCount);
    };
    $[5] = incrementCount;
    $[6] = setItems;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useSubscription(t4, t5);
}